




















import { Prop, Component } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { StatusName, CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwStatusFlag extends SwExtendedVue {
  @Prop({ type: String, default: 'normal' })
  name: StatusName;

  @Prop({ type: Number, default: undefined })
  blockSize: number;

  @Prop({ type: Number, default: 16 })
  iconSize: number;

  @Prop({ type: Boolean, default: false })
  asBlock: boolean;

  get iconName() {
    return utilService.statusInfoMap[this.name].icon;
  }

  get iconRotate() {
    if (this.name === 'up') { return 90; }
    if (this.name === 'down') { return -90; }
    return undefined;
  }

  get rootStyle(): CSSStyleOptions {
    const style: CSSStyleOptions = {};

    if (this.blockSize !== undefined) {
      style.width = `${this.blockSize}px`;
      style.height = `${this.blockSize}px`;
      if (this.blockSize > 24) {
        style.borderRadius = '3px';
      }
    }

    style.backgroundColor = utilService.statusInfoMap[this.name].color;

    return style;
  }
}
